import { render, staticRenderFns } from "./DropdownButtonOld.vue?vue&type=template&id=96625126&"
import script from "./DropdownButtonOld.vue?vue&type=script&lang=js&"
export * from "./DropdownButtonOld.vue?vue&type=script&lang=js&"
import style0 from "./DropdownButtonOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports